/**
 * Which environment a page is in, by the name it was loaded on. The portal
 * answers on its original dgtek name and on the Pineapple one, so production
 * is either; everything else (master, local) talks to the sandbox and test
 * systems.
 */
export const PRODUCTION_HOSTS = ['marketing.support.dgtek.net', 'hq.pineapple.net.au'];

export const isProductionHost = (host: string = window.location.host): boolean => (
  PRODUCTION_HOSTS.includes(host)
);

/** The signup a link from this page should send people to. */
export const signupSite = (host: string = window.location.host): string => (
  isProductionHost(host) ? 'https://signup.pineapple.net.au' : 'https://signup.master.pineapple.net.au'
);
